import "./BulkPatientSessionListComponent.scss";
import {ITableColumn} from "../../../shared/models/table.model";
import React, {useEffect, useState} from "react";
import {APIConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import commonService from "../../../shared/services/common.service";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import {Box, Typography, List, ListItem, ListItemText} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";

interface BulkPatientSessionListComponentProps {
    dataColumns: any[];
    bulkPatientID: any;
    moduleName: string;
}

const BulkPatientSessionListComponent = (props: BulkPatientSessionListComponentProps) => {
    const {bulkPatientID, dataColumns, moduleName} = props;
    const [finalColumns, setFinalColumns] = React.useState<ITableColumn[]>([]);

    const [columns] = useState<ITableColumn[]>([
        {
            id: 'patientDetails.prefix', label: 'Patient Prefix', align: 'center',
            content: (item: any) => (
                <>
                    {item?.patientDetails?.patientDetails?.prefix}
                </>
            )
        },
        {
            id: 'patientDetails.suffix', label: 'Patient Suffix', align: 'center',
            content: (item: any) => (
                <>
                    {item?.patientDetails?.patientDetails?.suffix}
                </>
            )
        },
        {
            id: 'patientDetails.firstName', label: 'Patient First Name', isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.patientDetails?.patientDetails?.firstName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientDetails?.firstName) : '-'}
                </>
            )
        },
        {
            id: 'patientDetails.middleName',
            label: 'Patient Middle Name',
            content: (item: any) => item?.patientDetails?.middleName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.middleName) : '-'
        },
        {
            id: 'patientDetails.lastName', label: 'Patient Last Name', isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.patientDetails?.patientDetails?.lastName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientDetails?.lastName) : '-'}
                </>
            )
        },
        {
            id: 'dateOfBirth', label: 'Patient Date of Birth', align: 'center',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.patientDetails?.patientDetails?.dateOfBirth}
                </>
            )
        },
        {
            id: "gender", label: "Gender", align: 'center',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.patientDetails?.patientDetails?.gender}
                </>
            )
        },
        {
            id: "mobileNumber", label: "Mobile Number", align: 'center',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.patientDetails?.patientDetails?.mobileNumber ? commonService.getMaskedMobileNumber(item?.patientDetails?.patientDetails?.mobileNumber) : '-'}
                </>
            )
        },
        {
            id: "emailId", label: "Email ID", align: 'center',
            isDefaultColumn: true,
            width: "200",
            content: (item: any) => (
                <div className={"ellipses-text"}>
                    {item?.patientDetails?.patientDetails?.emailId ? item?.patientDetails?.patientDetails?.emailId : '-'}
                </div>
            )
        },
        {
            id: "businessMobileNumber", label: "Business Mobile Number", align: 'center',
            isDefaultColumn: true,
            width: "200",
            content: (item: any) => (
                <>
                    {item?.patientDetails?.patientDetails?.businessMobileNumber ? commonService.getMaskedMobileNumber(item?.patientDetails?.patientDetails?.businessMobileNumber) : '-'}
                </>
            )
        },
        {
            id: "businessEmailId", label: "Business Email ID", align: 'center',
            isDefaultColumn: true,
            width: "200",
            content: (item: any) => (
                <div className={"ellipses-text"}>
                    {item?.patientDetails?.patientDetails?.businessEmailId ? item?.patientDetails?.patientDetails?.businessEmailId : '-'}
                </div>
            )
        },

        // {id: 'status', label: 'Status', content: (item: any) => item?.status || '-'},
        {
            id: 'patientDetails.race',
            label: 'Race',
            isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.race || '-'
        },
        {
            id: 'patientDetails.ethnicity',
            label: 'Ethnicity',
            isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.ethnicity || '-'
        },
        {
            id: 'patientDetails.addressLine1',
            label: 'Address Line 1',
            isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.addressLine1 || '-'
        },
        {
            id: 'patientDetails.addressLine2',
            label: 'Address Line 2',
            isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.addressLine2 || '-'
        },
        {
            id: 'patientDetails.city',
            label: 'City',
            isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.city || '-'
        },
        {
            id: 'patientDetails.state',
            label: 'State',
            isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.state || '-'
        },
        {
            id: 'patientDetails.zipcode',
            label: 'ZIP Code',
            isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.zipcode || '-'
        },
        {
            id: "county", label: "County", isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.county || '-'
        },
        {
            id: "country", label: "Country", isDefaultColumn: true,
            content: (item: any) => item?.patientDetails?.patientDetails?.country || '-'
        },
        {
            id: "aliasName", label: "Alias Name", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.aliasName || '-'
        },
        {
            id: "patientAccountNumber", label: "Patient Account Number", isDefaultColumn: false,
            width:'200',
            content: (item: any) => item?.patientDetails?.patientDetails?.patientAccountNumber || '-'
        },
        {
            id: "ssn", label: "Social Security Number (SSN)", isDefaultColumn: false,
            width:'200',
            content: (item: any) => item?.patientDetails?.patientDetails?.ssn || '-'
        },
        {
            id: "nationality", label: "Nationality", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.nationality || '-'
        },
        {
            id: "maritalStatus", label: "Marital Status", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.maritalStatus || '-'
        },
        {
            id: "degree", label: "Degree", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.degree || '-'
        },
        {
            id: "alternateId1", label: "Alternate ID 1", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.alternateId1 || '-'
        },
        {
            id: "alternateId2", label: "Alternate ID 2", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.alternateId2 || '-'
        },
        {
            id: "customField1", label: "Custom Field 1", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.customField1 || '-'
        },
        {
            id: "customField2", label: "Custom Field 2", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.customField2 || '-'
        },
        {
            id: "customField3", label: "Custom Field 3", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.customField3 || '-'
        },
        {
            id: "patientId1", label: "Patient ID 1", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.patientId1 || '-'
        },
        {
            id: "assignedBy1", label: "ID 1 Assigned By", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.assignedBy1 || '-'
        },
        {
            id: "patientId2", label: "Patient ID 2", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.patientId2 || '-'
        },
        {
            id: "assignedBy2", label: "ID 2 Assigned By", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.assignedBy2 || '-'
        },
        {
            id: "patientId3", label: "Patient ID 3", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.patientId3 || '-'
        },
        {
            id: "assignedBy3", label: "ID 3 Assigned By", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.assignedBy3 || '-'
        },
        {
            id: "drivingLicenseNumber", label: "Driving License Number", isDefaultColumn: false,
            width:'200',
            content: (item: any) => item?.patientDetails?.patientDetails?.drivingLicenseNumber || '-'
        },
        {
            id: "dateOfDeath", label: "Date of Death", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.dateOfDeath ? commonService.formatDate(item?.patientDetails?.patientDetails?.dateOfDeath) : '-'
        },
        {
            id: "timeOfDeath", label: "Time of Death", isDefaultColumn: false,
            content: (item: any) => item?.patientDetails?.patientDetails?.timeOfDeath ? commonService.convertTo12HourFormat(item?.patientDetails?.patientDetails?.timeOfDeath) : '-'
        },

        // Payer 1 columns
        {
            id: 'patientDetails.patientInsuranceDetails1.firstName',
            label: 'Payer 1: Subscriber First Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails1?.firstName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails1?.firstName) : "-"
            )
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.middleName',
            label: 'Payer 1: Subscriber Middle Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails1?.middleName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails1?.middleName) : '-'
            )
        },
        {
            id: 'patientInsuranceDetails1.lastName',
            label: 'Payer 1: Subscriber Last Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails1?.lastName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails1?.lastName) : '-'
            )
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.dateOfBirth',
            label: 'Payer 1: Subscriber DOB',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item?.patientDetails?.patientInsuranceDetails1?.dateOfBirth || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.insuranceCompany',
            label: 'Payer 1: Insurance Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.insuranceCompany || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.networkPlanName',
            label: 'Payer 1: Network Plan Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.networkPlanName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.groupName',
            label: 'Payer 1: Group Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.groupName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.groupNetwork',
            label: 'Payer 1: Group or Network Number',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.groupNetwork || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.ipaMedicalGroupName',
            label: 'Payer 1: Ipa or Medical Group Name',
            isDefaultColumn: true,
            width: 260,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.ipaMedicalGroupName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.policyNumber',
            label: 'Payer 1: Policy Number',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.policyNumber || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.relationship',
            label: 'Payer 1: Relationship to Insured',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.relationship || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.enbStatus',
            label: 'Payer 1: EnB Status',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.enbStatus || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails1.effectiveDate',
            label: 'Payer 1: Insurance Effective Date',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails1?.effectiveDate || '-'
        },

        // Payer 2 columns
        {
            id: 'patientDetails.patientInsuranceDetails2.firstName',
            label: 'Payer 2: Subscriber First Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails2?.firstName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails2?.firstName) : "-"
            )
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.middleName',
            label: 'Payer 2: Subscriber Middle Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails2?.middleName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails2?.middleName) : '-'
            )
        },
        {
            id: 'patientInsuranceDetails2.lastName',
            label: 'Payer 2: Subscriber Last Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails2?.lastName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails2?.lastName) : '-'
            )
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.dateOfBirth',
            label: 'Payer 2: Subscriber DOB',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item?.patientDetails?.patientInsuranceDetails2?.dateOfBirth || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.insuranceCompany',
            label: 'Payer 2: Insurance Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.insuranceCompany || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.networkPlanName',
            label: 'Payer 2: Network Plan Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.networkPlanName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.groupName',
            label: 'Payer 2: Group Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.groupName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.groupNetwork',
            label: 'Payer 2: Group or Network Number',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.groupNetwork || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.ipaMedicalGroupName',
            label: 'Payer 2: Ipa or Medical Group Name',
            isDefaultColumn: true,
            width: 260,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.ipaMedicalGroupName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.policyNumber',
            label: 'Payer 2: Policy Number',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.policyNumber || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.relationship',
            label: 'Payer 2: Relationship to Insured',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.relationship || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.enbStatus',
            label: 'Payer 2: EnB Status',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.enbStatus || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails2.effectiveDate',
            label: 'Payer 2: Insurance Effective Date',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails2?.effectiveDate || '-'
        },

        // Payer 3 columns
        {
            id: 'patientDetails.patientInsuranceDetails3.firstName',
            label: 'Payer 3: Subscriber First Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails3?.firstName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails3?.firstName) : "-"
            )
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.middleName',
            label: 'Payer 3: Subscriber Middle Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails3?.middleName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails3?.middleName) : '-'
            )
        },
        {
            id: 'patientInsuranceDetails3.lastName',
            label: 'Payer 3: Subscriber Last Name',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => (
                item?.patientDetails?.patientInsuranceDetails3?.lastName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientInsuranceDetails3?.lastName) : '-'
            )
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.dateOfBirth',
            label: 'Payer 3: Subscriber DOB',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item?.patientDetails?.patientInsuranceDetails3?.dateOfBirth || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.insuranceCompany',
            label: 'Payer 3: Insurance Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.insuranceCompany || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.networkPlanName',
            label: 'Payer 3: Network Plan Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.networkPlanName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.groupName',
            label: 'Payer 3: Group Name',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.groupName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.groupNetwork',
            label: 'Payer 3: Group or Network Number',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.groupNetwork || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.ipaMedicalGroupName',
            label: 'Payer 3: Ipa or Medical Group Name',
            isDefaultColumn: true,
            width: 260,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.ipaMedicalGroupName || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.policyNumber',
            label: 'Payer 3: Policy Number',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.policyNumber || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.relationship',
            label: 'Payer 3: Relationship to Insured',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.relationship || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.enbStatus',
            label: 'Payer 3: EnB Status',
            isDefaultColumn: true,
            width: 200,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.enbStatus || '-'
        },
        {
            id: 'patientDetails.patientInsuranceDetails3.effectiveDate',
            label: 'Payer 3: Insurance Effective Date',
            isDefaultColumn: true,
            width: 240,
            content: (item: any) => item.patientDetails?.patientInsuranceDetails3?.effectiveDate || '-'
        },

        //validation
        {
            id: 'validation',
            label: "Validation",
            isDefaultColumn: true,
            fixed: "right",
            width: 200,
            content: (item: { patientDetails: any }) => {
                const {patientDetails} = item;
                const validationErrors: Record<string, string[]> = {
                    ...patientDetails?.patientDetails?.validationErrors,
                    ...patientDetails?.patientInsuranceDetails1?.validationErrors,
                    ...patientDetails?.patientInsuranceDetails2?.validationErrors,
                    ...patientDetails?.patientInsuranceDetails3?.validationErrors,
                };

                // Convert the validation errors to a list format for display, removing asterisk from field names
                const errorMessages = Object.entries(validationErrors).map(([field, errors]) => (
                    <Box key={field}>
                        <List dense disablePadding>
                            <ListItem disableGutters>
                                <ListItemText
                                    primary={
                                        <Typography variant="body2">
                                            <strong>{commonService.capitalizeFirstLetterOfEachWord(field.replace('*', '') || "")}:</strong>{' '}
                                            <Typography component="span" variant="body2" color="error">
                                                {errors.join(', ')}
                                            </Typography>
                                        </Typography>
                                    }
                                />
                            </ListItem>
                        </List>
                    </Box>
                ));

                return (
                    Object.keys(validationErrors).length > 0 ? (
                        <TooltipComponent
                            tooltip={errorMessages}
                            placement="top"
                            arrow={true}
                        >
                            <div>
                                <ButtonComponent variant={'icon'} color={'error'}>
                                    <ErrorIcon/>
                                </ButtonComponent>
                            </div>
                        </TooltipComponent>
                    ) : (<ButtonComponent variant={'icon'} color={'success'}>
                        <CheckCircleIcon/>
                    </ButtonComponent>)
                );
            }
        }

    ]);

    useEffect(() => {
        const finalColumns = columns?.filter((column: ITableColumn) => {
            if (column.label.endsWith('*')) {
                column.label = column.label.slice(0, -1);
            }
            // eslint-disable-next-line array-callback-return
            return dataColumns?.find((dataColumn: any) => {
                const columnLabel = dataColumn.endsWith('*') ? dataColumn.slice(0, -1) : dataColumn;
                if (column.label === columnLabel) {
                    return column;
                }
            })
        });
        //Add validation column
        const validationColumn = columns.find((column: ITableColumn) => column.label === "Validation")
        if (validationColumn) {
            finalColumns.push(validationColumn)
        }
        setFinalColumns(finalColumns);

    }, [dataColumns, columns]);


    return (
        <div className={'bulk-test-order-session-list-component table-list-container'}>
            <TableWrapperV2Component
                isPaginated={true}
                columns={finalColumns}
                url={APIConfig.GET_BULK_PATIENT_SESSION_LIST.URL(bulkPatientID)}
                method={APIConfig.GET_BULK_PATIENT_SESSION_LIST.METHOD}
                isHoverable={true}
                isStickyHeader={true}
                isColumnFilterVisible={true}
                moduleName={moduleName}
            />
        </div>
    );

};

export default BulkPatientSessionListComponent;
